import { Icon } from "@zapier/design-system";
import { CopilotHeader } from "src/components/CopilotPage/CopilotHeader/CopilotHeader";
import styles from "./CopilotPage.module.css";

type CopilotPageProps = {
  templateName: string;
  templateImageUrl: string;
};

export const CopilotPage = ({
  templateName,
  templateImageUrl,
}: CopilotPageProps) => {
  return (
    <>
      <div className={styles.summaryCard}>
        <CopilotHeader
          templateName={templateName}
          templateImageUrl={templateImageUrl}
        />
      </div>
      <Icon name="miscCopilot" />
      Copilot
    </>
  );
};
